import { Component, OnInit } from '@angular/core';
import { latLng, tileLayer, marker, icon } from 'leaflet';

@Component({
	selector: 'app-map',
	templateUrl: './map.component.html',
	styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {
	options = {
		layers: [
			tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				maxZoom: 18,
				attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
			})
		],
		zoom: 15,
		center: latLng(45.714465, 3.070409),
		scrollWheelZoom: false
	};

	saulzet = marker([45.714465, 3.070409], {
		icon: icon({
			iconSize: [25, 41],
			iconAnchor: [13, 41],
			iconUrl: 'leaflet/marker-icon.png',
			shadowUrl: 'leaflet/marker-shadow.png',
			popupAnchor: [0, -30]
		})
	}).bindPopup(
		'<b>Pizza Mitch</b><br/>Parking Restaurant La Chaumière<br/>Saulzet-le-Chaud<br/>Mar–Sam · 16h30–21h00'
	);

	constructor() { }

	ngOnInit() {
		setTimeout(() => {
			this.saulzet.openPopup();
		}, 800);
	}

}
